import React, { useState, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Layout from "../PageLayout/LoginLayout";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { resetPassword } from "../services/auth.service";

export default function ChangePassword() {
  const navigate = useNavigate();
  const location = useLocation();
  const email = useMemo(() => {
    const qp = new URLSearchParams(location.search);
    return qp.get("email") || location.state?.email || (() => {
      try { return localStorage.getItem("pendingPasswordResetEmail") || ""; } catch { return ""; }
    })();
  }, [location]);
  const code = useMemo(() => {
    const qp = new URLSearchParams(location.search);
    return qp.get("code") || location.state?.code || (() => {
      try { return localStorage.getItem("pendingPasswordResetCode") || ""; } catch { return ""; }
    })();
  }, [location]);

  const [newPassword, setNewPassword] = useState("");
  const [showNew, setShowNew] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    if (e && typeof e.preventDefault === "function") e.preventDefault();
    setError("");
    if (!email || !code) {
      setError("Missing email or code. Please go back and verify again.");
      return;
    }
    if (!newPassword) {
      setError("Please enter a new password.");
      return;
    }
    setLoading(true);
    try {
      await resetPassword(email, code, newPassword);
      navigate("/password-success");
    } catch (e) {
      const msg = e?.response?.data?.message || e.message || "Failed to change password.";
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div className="flex min-h-screen items-center justify-center px-4">
        <div className="w-full max-w-md mx-auto">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="mb-4 inline-flex items-center gap-2 text-sm text-gray-600 hover:text-gray-800"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="h-4 w-4">
              <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 111.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" transform="scale(-1,1) translate(-20,0)" />
            </svg>
            Back
          </button>
          <h2 className="text-2xl font-semibold mb-2">Set a new password</h2>
          <p className="text-sm text-gray-500 mb-6">Enter your new password for {email}.</p>

          <form onSubmit={handleSubmit}>
            {error && <p className="text-red-500 text-sm mb-3">{error}</p>}

            <div className="mb-4 relative">
              <input
                type={showNew ? "text" : "password"}
                placeholder="New password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                className="w-full border border-gray-300 rounded-md py-2 px-3 pr-10"
              />
              <button type="button" className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400" onClick={() => setShowNew((v) => !v)} tabIndex={-1}>
                {showNew ? <FiEyeOff /> : <FiEye />}
              </button>
            </div>

            <button type="submit" disabled={loading} className="w-full bg-[#1E1E2F] text-white rounded-md py-3 text-base font-medium hover:bg-gray-800">
              {loading ? "Saving..." : "Continue"}
            </button>
          </form>
        </div>
      </div>
    </Layout>
  );
}


